import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Divider, Grid } from '@mui/material';

import { IInboundInvoiceWaitingApprovalListItem } from 'commons/types';
import { getWaitingApprovalInvoiceList } from 'redux-stores/actions';
import { RootReducerInterface } from 'redux-stores/reducers';
import { AppDispatch } from 'redux-stores/store';
import { INBOUND_ROUTES } from 'routes/constants';

import { IInboundInvoiceApprovalListStyle as S } from './InboundInvoiceApprovalList.styles';

export const IInboundInvoiceApprovalListPage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const { waitingApprovalInvoiceList } = useSelector(
    (state: RootReducerInterface) => state.inboundInvoice,
  );

  const [filter, setFilter] = useState<string>('');
  const [displayedInvoiceList, setDisplayedInvoiceList] = useState<
    IInboundInvoiceWaitingApprovalListItem[]
  >([]);

  useEffect(() => {
    dispatch(getWaitingApprovalInvoiceList());
  }, [dispatch]);

  useEffect(() => {
    if (!filter) {
      setDisplayedInvoiceList(waitingApprovalInvoiceList);
    } else {
      // search substring of filter to match invoice number
      const updatedList = structuredClone(waitingApprovalInvoiceList);
      setDisplayedInvoiceList(
        updatedList.filter((invoice) =>
          invoice.invoice_number.includes(filter),
        ),
      );
    }
  }, [filter, waitingApprovalInvoiceList]);

  const handleSetInvoiceDetail = (
    invoice: IInboundInvoiceWaitingApprovalListItem,
  ): void => {
    navigate(INBOUND_ROUTES.APPROVAL, {
      state: {
        invoiceNumber: invoice.invoice_number,
        inboundTaskNumber: invoice.inbound_task_number,
      },
    });
  };

  // render additional section
  const renderInvoiceList = (): React.JSX.Element[] =>
    displayedInvoiceList.map((invoice, idx) => (
      <>
        <S.TaskItemWrapper
          container
          // eslint-disable-next-line react/no-array-index-key
          key={`inbound-approval-list-header-${idx}`}
        >
          <S.TaskItemDescription item xs={3}>
            <p>{invoice.invoice_number}</p>
          </S.TaskItemDescription>
          <S.TaskItemDescription item xs={4}>
            <p>{invoice.inbound_task_number}</p>
          </S.TaskItemDescription>
          <S.TaskItemQTY item xs={2}>
            <div
              style={{ textAlign: 'center', paddingRight: 8, paddingTop: 4 }}
            >
              QTY: {invoice.total_qty} <br />
              SKUs: {invoice.total_sku}
            </div>
          </S.TaskItemQTY>
          <Grid item xs={3}>
            <S.SecondaryButton
              sx={{ marginTop: '2px !important' }}
              onClick={() => handleSetInvoiceDetail(invoice)}
            >
              Details
            </S.SecondaryButton>
          </Grid>
        </S.TaskItemWrapper>
        <Divider />
      </>
    ));

  return (
    <div>
      <S.ContentWrapper>
        {/* Search bar section */}
        <Grid container style={{ padding: '8px 0' }} spacing={1}>
          <Grid item xs={12}>
            <S.SearchBar
              placeholder="Input Invoice Number"
              variant="outlined"
              value={filter}
              onChange={(event) => setFilter(event.target.value)}
              inputProps={{
                'data-testid': 'InboundItemSearchPO',
              }}
            />
          </Grid>
        </Grid>

        {/* Inbound Task Items Section */}
        {displayedInvoiceList && renderInvoiceList()}
      </S.ContentWrapper>
    </div>
  );
};
